"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logPlaidItemActivityWatcher = exports.discoverInstitutionLoginWithAccountsByPollingWatcher = exports.discoverInstitutionLoginWithAccountsWatcher = exports.getAggregationInfoWatcher = exports.addInstitutionLoginsAndAccountsWatcher = exports.getPartnerAuthUrisWatcher = exports.accountDiscoveryMfaFormWatcher = exports.accountDiscoveryCredentialsFormSubmitWatcher = exports.logPlaidItemEvent = exports.discoverInstitutionLoginWithAccountsByPolling = exports.discoverInstitutionLoginWithAccounts = exports.getAggregationInfo = exports.addInstitutionLoginAndAccounts = exports.getPartnerAuthUris = exports.submitMfaResponses = exports.accountDiscovery = void 0;
const effects_1 = require("redux-saga/effects");
const node_forge_1 = __importDefault(require("node-forge"));
const lodash_1 = __importDefault(require("lodash"));
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const institutionsActions = __importStar(require("companion-app-components/flux/institutions/institutionsActions"));
const institutionsUtils_1 = require("companion-app-components/flux/institutions/institutionsUtils");
const institutionLoginsActions = __importStar(require("data/institutionLogins/actions"));
const selectors_1 = require("data/institutionLogins/selectors");
const transformers_1 = require("data/institutionLogins/transformers");
const actionHelpers_1 = require("utils/actionHelpers");
const axiosFactory_1 = __importDefault(require("utils/axiosFactory"));
const actions = __importStar(require("./actions"));
const selectors = __importStar(require("./selectors"));
const transformers = __importStar(require("./transformers"));
const types = __importStar(require("./types"));
const log = (0, core_1.getLogger)('data/AccountDiscovery/sagas.ts');
const qcsAxios = axiosFactory_1.default.get('qcs');
// poll every 3 seconds up to a total of 3 minutes and 30 seconds (seconds are buffer over QCS timeouts)
const REFRESH_POLL_INTERVAL = 3;
const REFRESH_POLL_ATTEMPTS = 210 / REFRESH_POLL_INTERVAL;
function* poll(url, institutionLoginId, meta) {
    let response;
    let timeout = REFRESH_POLL_ATTEMPTS;
    while (timeout > 0) {
        try {
            log.log(`Number of times left to poll is ${timeout} #account-discovery`);
            response = yield (0, effects_1.call)(qcsAxios.get, url);
            log.debug('Polling upserted institition-logins, response=', response.data);
            const adStatus = transformers.transformResponseToAccountDiscoveryStatus(response);
            yield (0, effects_1.put)(actions.accountDiscoveryStatus({ status: adStatus }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            const { data } = response;
            if (data.status === 'ACTION_REQUIRED') {
                const { aggregators } = response.data;
                if (aggregators.length !== 1) {
                    throw new Error('Unsupported number of aggregators when extracting MFA Challenge');
                }
                const aggregator = aggregators[0];
                if (aggregator.aggStatus !== 'MFA_CHALLENGE_READY_FOR_USER') {
                    throw new Error('Trying to transform response to MFA Challenge when aggStatus != MFA_CHALLENGE_READY_FOR_USER');
                }
                // todo: this should really come from QCS
                const submitUrl = `/institution-logins/${data.institutionLoginId}/mfa-response`;
                const mfaChallenge = (0, transformers_1.transformMfaResponseToMfaChallenge)(data.institutionLoginId, aggregator.mfaChallenges, submitUrl);
                yield (0, effects_1.put)(actions.accountDiscoveryMfaRequired({ mfaChallenge }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            }
            if (!data.isProcessing) {
                // if QCS detects we are attempting to modify existing login, switch it to the one QCS detected
                if (data.existingInstitutionLoginId) {
                    // eslint-disable-next-line no-param-reassign
                    institutionLoginId = data.existingInstitutionLoginId;
                }
                const existingInstitutionLogin = yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, institutionLoginId);
                assert(existingInstitutionLogin, `institution login with id = ${institutionLoginId} not found`);
                if (data.status === 'OK') {
                    if (data.mode === 'UPDATE_CREDENTIALS') {
                        yield (0, effects_1.put)(actions.accountDiscoverySuccess({ institutionLogin: existingInstitutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
                    }
                    else {
                        const allAccountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
                        const accountDiscoveryData = transformers.transformResponseToAccountDiscoveryData(data, allAccountsById);
                        yield (0, effects_1.put)(actions.accountDiscoverySuccessWithAccounts({ institutionLogin: existingInstitutionLogin, accountDiscoveryData }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
                    }
                }
                else if (data.status !== 'ACTION_REQUIRED') {
                    log.log('Status is in another terminated state', data.status);
                    yield (0, effects_1.put)(actions.accountDiscoveryFailure({ adStatus, institutionLogin: existingInstitutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
                }
                else {
                    yield (0, effects_1.put)(actions.accountDiscoveryStopped({ adStatus, institutionLogin: existingInstitutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
                }
                // server is done processing so stop polling
                return;
            }
            timeout -= 1;
            yield (0, effects_1.delay)(REFRESH_POLL_INTERVAL * 1000);
        }
        catch (error) {
            assert(false, error);
            // TODO: I believe this may cause an exception, institionLogin likely doesn't exist in our Redux store for new Add-FI
            const institutionLogin = yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, institutionLoginId);
            yield (0, effects_1.put)(actions.accountDiscoveryError({ error, institutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            return;
        }
    }
    // time-out
    log.log('Time-out #account-discovery');
    const institutionLogin = yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, institutionLoginId);
    const error = new types.AccountDiscoveryFailure('Account Discovery Timeout', 'AD_TIMEOUT', 'to.100');
    yield (0, effects_1.put)(actions.accountDiscoveryError({ error, institutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
}
function* accountDiscovery(action) {
    var _a, _b, _c, _d, _e, _f;
    const { payload: { institutionLogin }, meta } = action;
    const { resolve, reject, scope } = meta;
    let resolvedInstitutionLogin = institutionLogin;
    let institutionLoginId = institutionLogin.id !== '0' ? institutionLogin.id : null;
    let requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/institution-logins`;
    if (institutionLoginId) {
        requestUrl += `/${institutionLoginId}`;
    }
    let requestBody = transformers.transformInstitutionLoginToRequestData(institutionLogin);
    let isSecure = true;
    const fiCredentialEncryption = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlag, 'fiCredentialEncryption');
    if (fiCredentialEncryption) {
        const institution = yield (0, effects_1.select)(selectors.getInstitution, { scope });
        const channelData = yield (0, effects_1.select)(selectors.getInstitutionChannelData, { scope });
        if (channelData.authType === 'CREDENTIAL_AUTH') {
            try { // get public key: dig -t TXT services-bld.quickencs.com +short
                assert((_b = (0, core_1.getEnvironmentConfig)()) === null || _b === void 0 ? void 0 : _b.signature_public_key, 'public key for signature not found #encrypt');
                const signaturePublicKey = node_forge_1.default.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----${(_c = (0, core_1.getEnvironmentConfig)()) === null || _c === void 0 ? void 0 : _c.signature_public_key}-----END PUBLIC KEY-----`);
                // verify form signature 'displayOrder:cpId:encrypt;displayOrder:cpId:encrypt'
                if (assert(channelData, 'can not verify form signature: aggregator not found #encrypt')
                    && assert(channelData.formSignatureAlgorithm === 'SHA256withRSA', 'unexpected form signature algorithm #encrypt')
                    && assert(signaturePublicKey, 'public key for form signature not found #encrypt')) {
                    const formData = channelData.formFields.map((formField) => `${formField.displayOrder}:${formField.key}:${formField.encrypt}`).join(';');
                    const dataToVerify = node_forge_1.default.md.sha256.create().update(formData, 'utf8');
                    const verify = signaturePublicKey.verify(dataToVerify.digest().bytes(), node_forge_1.default.util.decode64(channelData.formSignature));
                    assert(verify, 'form signature verification failed #encrypt');
                    // @ts-expect-error: The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
                    isSecure &= verify;
                }
                else {
                    isSecure = false;
                }
                // verify encryption key signature
                const { formEncryption } = channelData;
                if (assert(formEncryption.signatureAlgorithm === 'SHA256withRSA', 'unexpected encryption signature algorithm #encrypt')
                    && assert(signaturePublicKey, 'public key for signature not found #encrypt')) {
                    const dataToVerify = node_forge_1.default.md.sha256.create().update(formEncryption.publicKey, 'utf8');
                    const verify = signaturePublicKey.verify(dataToVerify.digest().bytes(), node_forge_1.default.util.decode64(formEncryption.signature));
                    assert(verify, 'encryption key signature verification failed #encrypt');
                    // @ts-expect-error: The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
                    isSecure &= verify;
                }
                else {
                    isSecure = false;
                }
                if (assert((formEncryption === null || formEncryption === void 0 ? void 0 : formEncryption.algorithm) === 'RSA', `unexpected encryption algorithm "${formEncryption === null || formEncryption === void 0 ? void 0 : formEncryption.algorithm}" #encrypt`)
                    && assert(formEncryption === null || formEncryption === void 0 ? void 0 : formEncryption.publicKey, 'encryption key not found #encrypt')) {
                    requestBody.credentials = (_d = requestBody.credentials) === null || _d === void 0 ? void 0 : _d.map((field) => {
                        const institutionFormField = channelData.formFields.find((formField) => formField.key === field.key);
                        if (institutionFormField === null || institutionFormField === void 0 ? void 0 : institutionFormField.encrypt) {
                            const pem = `-----BEGIN PUBLIC KEY-----${formEncryption.publicKey}-----END PUBLIC KEY-----`;
                            const publicKey = node_forge_1.default.pki.publicKeyFromPem(pem);
                            const encryptedValue = publicKey.encrypt(node_forge_1.default.util.encodeUtf8(field.value));
                            const value = btoa(encryptedValue);
                            return Object.assign(Object.assign({}, field), { encrypted: true, encryptionKeyId: formEncryption.keyId, value });
                        }
                        return field;
                    });
                }
                else {
                    isSecure = false;
                }
            }
            catch (error) {
                assert(false, `${String(error)} #encrypt`);
                core_1.crashReporterInterface.reportError(error, (event) => event.addMetadata('custom', {
                    institutionId: institutionLogin.institutionId,
                    institution,
                    aggregator: institution.aggregator,
                }));
                isSecure = false;
            }
        }
        if (!isSecure) {
            core_1.crashReporterInterface.reportError(Error('encryption failed (details)'), (event) => event.addMetadata('custom', {
                institutionId: institutionLogin.institutionId,
                institution,
                aggregator: institution.aggregator,
            }));
            const error = new types.AccountDiscoveryFailure('Unable to encrypt credentials', 'AD_UNABLE_TO_ENCRYPT_CREDENTIALS', 'vs.100');
            yield (0, effects_1.put)(actions.accountDiscoveryError({ error, institutionLogin: resolvedInstitutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            yield (0, effects_1.call)(reject, { error });
            const aggregator = (0, institutionsUtils_1.getAggregatorFromChannel)(institution.channel);
            yield (0, effects_1.put)(institutionsActions.getInstitution({ id: institutionLogin.institutionId }, (0, actionHelpers_1.cpMetaForEmbeddedAction)(lodash_1.default.merge(meta, { axiosConfig: { params: { aggregator } } }))));
            return;
        }
    }
    try {
        const httpMethod = institutionLoginId ? qcsAxios.put : qcsAxios.post;
        const response = yield (0, effects_1.call)(httpMethod, requestUrl, requestBody);
        log.log('Upserted institition-login, response=', response.data);
        if (!institutionLoginId) {
            institutionLoginId = response.data.id;
            resolvedInstitutionLogin = resolvedInstitutionLogin.set('id', institutionLoginId);
        }
    }
    catch (exceptionError) {
        log.log('Received error', exceptionError, exceptionError.response);
        let error = exceptionError;
        if (error.response) {
            if (!institutionLoginId && error.response.status === 409 && error.response.data.errors[0].extData.attributeName === 'Credentials') {
                log.debug('Received 409 response, turning request into update');
                // Server detected that we are creating a login in which we already have one for the same username; so,
                // until server does it, we will redo requesting after changing to an update instead of create
                try {
                    institutionLoginId = error.response.data.errors[0].extData.conflictId;
                    const conflictingInstitutionLogin = yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, institutionLoginId);
                    // here we are swapping out institutionLogin to the conflicting institutionLogin
                    //
                    resolvedInstitutionLogin = conflictingInstitutionLogin.merge({
                        credentials: institutionLogin.credentials,
                    });
                    requestUrl = `${(_e = (0, core_1.getEnvironmentConfig)()) === null || _e === void 0 ? void 0 : _e.services_url}/institution-logins`;
                    requestUrl += `/${institutionLoginId}`;
                    requestBody = transformers.transformInstitutionLoginToRequestData(resolvedInstitutionLogin);
                    const response = yield (0, effects_1.call)(qcsAxios.put, requestUrl, requestBody);
                    log.log('Upserted conflicting institution-login, response=', response.data);
                    // clear error since put was sucessful
                    error = null;
                }
                catch (exceptionError2) {
                    error = exceptionError2;
                }
            }
        }
        if (error) {
            log.log('Error upserting institution-login, error=', error);
            yield (0, effects_1.put)(actions.accountDiscoveryCredentialsFormSubmitResponse(error, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            yield (0, effects_1.put)(actions.accountDiscoveryError({ error, institutionLogin: resolvedInstitutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            yield (0, effects_1.call)(reject, { institutionLogin: resolvedInstitutionLogin, error });
            // if in error, don't continue
            return;
        }
    }
    yield (0, effects_1.put)(actions.accountDiscoveryCredentialsFormSubmitResponse({ institutionLogin: resolvedInstitutionLogin }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    yield (0, effects_1.call)(resolve, resolvedInstitutionLogin);
    yield (0, effects_1.put)(institutionLoginsActions.getInstitutionLogins());
    // make flow happy
    institutionLoginId = institutionLoginId || '0';
    // poll until institution-login is ready or cancel action
    requestUrl = `${(_f = (0, core_1.getEnvironmentConfig)()) === null || _f === void 0 ? void 0 : _f.services_url}/institution-logins/${institutionLoginId}/poll`;
    yield* poll(requestUrl, institutionLoginId, meta);
}
exports.accountDiscovery = accountDiscovery;
function* submitMfaResponses({ payload: { mfaResponse }, meta }) {
    var _a, _b;
    log.log('Submitting MFA Response for Account Discovery', mfaResponse);
    const { resolve, reject } = meta;
    let requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}${mfaResponse.submitUrl}`;
    const requestBody = {
        institutionLoginId: mfaResponse.institutionLoginId,
        mfaResponses: mfaResponse.answers.map((answer) => ({
            key: answer.id,
            response: answer.value,
        })),
    };
    try {
        yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestBody);
        yield (0, effects_1.put)(actions.accountDiscoveryMfaFormSubmitResponse({}, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
        yield (0, effects_1.call)(resolve, mfaResponse.institutionLoginId);
    }
    catch (error) {
        log.error('Received error', error);
        yield (0, effects_1.put)(actions.accountDiscoveryMfaFormSubmitResponse(error, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
        yield (0, effects_1.call)(reject, { error });
        // if in error, don't continue
        return;
    }
    // poll until institution-login is ready or cancel action
    requestUrl = `${(_b = (0, core_1.getEnvironmentConfig)()) === null || _b === void 0 ? void 0 : _b.services_url}/institution-logins/${mfaResponse.institutionLoginId}/poll`;
    yield* poll(requestUrl, mfaResponse.institutionLoginId, meta);
}
exports.submitMfaResponses = submitMfaResponses;
// =================================================================================================
// getPartnerAuthUri
// =================================================================================================
function* getPartnerAuthUris({ payload, meta }) {
    var _a;
    log.debug('getPartnerAuthUris called...', payload);
    const { partnerAuth, redirectUri } = payload;
    const { intuitProperty, partnerUid } = partnerAuth;
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/intuit-partnerauth?intuit_property=${intuitProperty}&partner_uid=${partnerUid}&offering_redirect_uri=${redirectUri}`;
    try {
        const response = yield (0, effects_1.call)(qcsAxios.get, requestUrl);
        log.debug('Retrieved partnerAuthUris, response=', response);
        const partnerAuthUris = transformers.transformResponseToPartnerAuthUris(response);
        log.debug('getPartnerAuthUris response after transform=', partnerAuthUris);
        yield (0, effects_1.put)(actions.getPartnerAuthUrisSuccess({ partnerAuthUris }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    }
    catch (error) {
        log.debug('Error retrieving partnerAuthUris', error);
        yield (0, effects_1.put)(actions.getPartnerAuthUrisFailure({ error }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    }
}
exports.getPartnerAuthUris = getPartnerAuthUris;
function transformAddInstitutionLoginAndAccountsPayloadWithResponse(institutionLogin, accounts, response) {
    const updatedInstitutionLogin = institutionLogin.set('id', response.data.id);
    const { correlationIds } = response.data;
    const updatedAccounts = accounts.map((account) => {
        var _a;
        const accountId = correlationIds[(_a = account.clientId) !== null && _a !== void 0 ? _a : ''];
        return account.merge({
            id: accountId || account.id,
            institutionLoginId: updatedInstitutionLogin.id,
            isDeleted: account.isDeleted || account.isIgnored,
        });
    });
    return [updatedInstitutionLogin, updatedAccounts];
}
function* doAddInstitutionLoginAndAccountsPolling(url, institutionLoginId, meta) {
    let numTimesLeftToPoll = REFRESH_POLL_ATTEMPTS;
    while (numTimesLeftToPoll > 0) {
        try {
            const response = yield (0, effects_1.call)(qcsAxios.get, url);
            log.log('Polling for refresh status', response.data);
            const refreshStatus = (0, transformers_1.transformResponseToRefreshStatus)(response.data);
            log.log('Status after transforming...', refreshStatus);
            // send refresh status
            yield (0, effects_1.put)(institutionLoginsActions.refreshAccountsStatuses(refreshStatus));
            if (!response.data.isProcessing) {
                yield (0, effects_1.put)(institutionLoginsActions.refreshAccountsCompleted({ institutionLoginId, status: 'DONE_PROCESSING' }));
                // since we are done processing, stop polling
                break;
            }
            numTimesLeftToPoll -= 1;
            log.log(`Number of times left to poll is ${numTimesLeftToPoll} #add-account`);
            yield (0, effects_1.delay)(REFRESH_POLL_INTERVAL * 1000);
        }
        catch (error) {
            log.log('How did we get here...', error);
            yield (0, effects_1.put)(institutionLoginsActions.refreshAccountsCompleted({ institutionLoginId, status: 'FAILED_WHEN_POLLING' }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
            break;
        }
    }
    if (numTimesLeftToPoll === 0) {
        yield (0, effects_1.put)(institutionLoginsActions.refreshAccountsCompleted({ institutionLoginId, status: 'TIMEOUT_WHILE_PROCESSING' }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    }
}
// =================================================================================================
// addInstitutionLoginAndAccounts
// =================================================================================================
function* addInstitutionLoginAndAccounts({ payload: { institutionLogin, accounts }, meta }) {
    var _a, _b;
    log.log('Creating InstitutionLogin with accounts', institutionLogin, accounts);
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/institution-logins`;
    const requestBody = transformers.transformInstitutionLoginToRequestData(institutionLogin, accounts);
    let institutionLoginId = null;
    let pollingUrl = null;
    try {
        const response = yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestBody);
        log.debug('Created institition-login and added accounts, response=', response.data);
        const [updatedInstitutionLogin, updatedAccounts] = transformAddInstitutionLoginAndAccountsPayloadWithResponse(institutionLogin, accounts, response);
        log.debug('Transformed values', updatedInstitutionLogin, updatedAccounts);
        institutionLoginId = updatedInstitutionLogin.id;
        pollingUrl = `${(_b = (0, core_1.getEnvironmentConfig)()) === null || _b === void 0 ? void 0 : _b.services_url}${response.data.pollingReference}`;
        yield (0, effects_1.put)(institutionLoginsActions.addInstitutionLoginAndAccountsResponse({ institutionLogin: updatedInstitutionLogin, accounts: updatedAccounts }, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    }
    catch (error) {
        log.log('Error adding institution-login and accounts, error=', error);
        yield (0, effects_1.put)(institutionLoginsActions.addInstitutionLoginAndAccountsResponse(error, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
        // if in error, don't continue
        return;
    }
    yield* doAddInstitutionLoginAndAccountsPolling(pollingUrl, institutionLoginId, meta);
}
exports.addInstitutionLoginAndAccounts = addInstitutionLoginAndAccounts;
// =================================================================================================
// getAggregationInfo
//
// Retrieves aggregation-info required for some aggregators. For example,
//   - Finicity
//     - Requires Connect URI
//     - Requires Polling Reference Used to Retrieve Discovered Accounts
//   - Plaid
//     - Requires Plaid Link Token
// =================================================================================================
function* getAggregationInfo({ payload: { institution, channel, institutionLogin }, meta }) {
    var _a;
    log.debug('getAggregationInfo called...', institution, channel, institutionLogin);
    const { resolve, reject } = meta;
    let requestUrlParams = institutionLogin ? `/${institutionLogin.id}?channel=${channel}` : `?channel=${channel}`;
    if (institution) {
        requestUrlParams += `&institutionId=${institution.id}`;
    }
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/institutions/aggregation-info${requestUrlParams}`;
    try {
        const response = yield (0, effects_1.call)(qcsAxios.get, requestUrl);
        const transformedResponse = transformers.transformResponseToAggregationInfo(response);
        log.debug('Retrieved aggregationInfo', transformedResponse, response);
        yield (0, effects_1.call)(resolve, transformedResponse);
    }
    catch (error) {
        log.debug('Error retrieving aggregation info', error);
        yield (0, effects_1.call)(reject, error);
    }
}
exports.getAggregationInfo = getAggregationInfo;
// =================================================================================================
// discoverInstitutionLoginWithAccounts
//
// This is used to build a discover response from an institution login and accounts.
// =================================================================================================
function* discoverInstitutionLoginWithAccounts({ payload: { institutionLogin, accounts }, meta }) {
    var _a;
    log.log('Discovering institition-login with accounts', institutionLogin, accounts);
    const { resolve, reject } = meta;
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/institution-logins/discover`;
    const requestBody = transformers.transformInstitutionLoginToRequestData(institutionLogin, accounts);
    try {
        const response = yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestBody);
        const institutionLoginToUpsert = response.data.existingInstitutionLoginId && response.data.existingInstitutionLoginId !== institutionLogin.id
            ? yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, response.data.existingInstitutionLoginId)
            : institutionLogin;
        const allAccountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
        const accountDiscoveryData = transformers.transformResponseToAccountDiscoveryData(response.data, allAccountsById);
        log.debug('Transformed values', institutionLoginToUpsert, accountDiscoveryData);
        yield (0, effects_1.call)(resolve, { institutionLogin: institutionLoginToUpsert, accountDiscoveryData });
    }
    catch (error) {
        log.debug('Error discovering institution-login with accounts, error=', error);
        yield (0, effects_1.call)(reject, error);
    }
}
exports.discoverInstitutionLoginWithAccounts = discoverInstitutionLoginWithAccounts;
// =================================================================================================
// discoverInstitutionLoginWithAccountsByPolling
//
// This is used to build a discover response from an institution login and accounts.
// =================================================================================================
function* discoverInstitutionLoginWithAccountsByPolling({ payload: { institutionLogin, pollingRef }, meta }) {
    var _a;
    log.log('Discovering institition-login with accounts by polling', institutionLogin, pollingRef);
    const { resolve, reject } = meta;
    const url = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/${pollingRef}`;
    let timeout = REFRESH_POLL_ATTEMPTS;
    while (timeout > 0) {
        try {
            const response = yield (0, effects_1.call)(qcsAxios.get, url);
            log.log('Polling for discovered accounts', response.data);
            const { data } = response;
            if (!data.isProcessing) {
                const institutionLoginToUpsert = response.data.existingInstitutionLoginId && response.data.existingInstitutionLoginId !== institutionLogin.id
                    ? yield (0, effects_1.select)(selectors_1.getInstitutionLoginForId, response.data.existingInstitutionLoginId)
                    : transformers.mergeDiscoveryAggregatorsWithInstitutionLogin(response.data.aggregators, institutionLogin);
                const allAccountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
                const accountDiscoveryData = transformers.transformResponseToAccountDiscoveryData(response.data, allAccountsById);
                log.debug('Transformed values', institutionLoginToUpsert, accountDiscoveryData);
                yield (0, effects_1.call)(resolve, { institutionLogin: institutionLoginToUpsert, accountDiscoveryData });
                // server is done processing so stop polling
                return;
            }
            timeout -= 1;
            yield (0, effects_1.delay)(REFRESH_POLL_INTERVAL * 1000);
        }
        catch (error) {
            log.debug('Error discovering institution-login with accounts, error=', error);
            yield (0, effects_1.call)(reject, error);
            return;
        }
    }
}
exports.discoverInstitutionLoginWithAccountsByPolling = discoverInstitutionLoginWithAccountsByPolling;
// =================================================================================================
// logPlaidItemEvent
// =================================================================================================
function* logPlaidItemEvent({ payload: { institutionLogin, event }, meta }) {
    var _a;
    log.info('Logging Plaid event', institutionLogin, event);
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/institution-logins/log-user-activity`;
    const requestBody = transformers.transformPlaidItemActivityToRequestData(institutionLogin, event);
    try {
        yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestBody);
        yield (0, effects_1.put)(actions.logPlaidItemEventResponse(null, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    }
    catch (error) {
        log.error('Error logging Plaid activity, error=', error);
        yield (0, effects_1.put)(actions.logPlaidItemEventResponse(error, (0, actionHelpers_1.cpMetaForResponseAction)(meta)));
    }
}
exports.logPlaidItemEvent = logPlaidItemEvent;
function* accountDiscoveryCredentialsFormSubmitWatcher() {
    yield (0, effects_1.takeLatest)(actions.accountDiscoveryCredentialsFormSubmit, accountDiscovery);
}
exports.accountDiscoveryCredentialsFormSubmitWatcher = accountDiscoveryCredentialsFormSubmitWatcher;
function* accountDiscoveryMfaFormWatcher() {
    yield (0, effects_1.takeLatest)(actions.accountDiscoveryMfaFormSubmit, submitMfaResponses);
}
exports.accountDiscoveryMfaFormWatcher = accountDiscoveryMfaFormWatcher;
function* getPartnerAuthUrisWatcher() {
    yield (0, effects_1.takeLatest)(actions.getPartnerAuthUris, getPartnerAuthUris);
}
exports.getPartnerAuthUrisWatcher = getPartnerAuthUrisWatcher;
function* addInstitutionLoginsAndAccountsWatcher() {
    yield (0, effects_1.takeLatest)(institutionLoginsActions.addInstitutionLoginAndAccounts, addInstitutionLoginAndAccounts);
}
exports.addInstitutionLoginsAndAccountsWatcher = addInstitutionLoginsAndAccountsWatcher;
function* getAggregationInfoWatcher() {
    yield (0, effects_1.takeLatest)(actions.getAggregationInfo, getAggregationInfo);
}
exports.getAggregationInfoWatcher = getAggregationInfoWatcher;
function* discoverInstitutionLoginWithAccountsWatcher() {
    yield (0, effects_1.takeLatest)(actions.discoverInstitutionLoginWithAccounts, discoverInstitutionLoginWithAccounts);
}
exports.discoverInstitutionLoginWithAccountsWatcher = discoverInstitutionLoginWithAccountsWatcher;
function* discoverInstitutionLoginWithAccountsByPollingWatcher() {
    yield (0, effects_1.takeLatest)(actions.discoverInstitutionLoginWithAccountsByPolling, discoverInstitutionLoginWithAccountsByPolling);
}
exports.discoverInstitutionLoginWithAccountsByPollingWatcher = discoverInstitutionLoginWithAccountsByPollingWatcher;
function* logPlaidItemActivityWatcher() {
    yield (0, effects_1.takeLatest)(actions.logPlaidItemEvent, logPlaidItemEvent);
}
exports.logPlaidItemActivityWatcher = logPlaidItemActivityWatcher;
// Load all watcher sagas
exports.default = [
    accountDiscoveryCredentialsFormSubmitWatcher,
    accountDiscoveryMfaFormWatcher,
    getPartnerAuthUrisWatcher,
    addInstitutionLoginsAndAccountsWatcher,
    getAggregationInfoWatcher,
    discoverInstitutionLoginWithAccountsWatcher,
    discoverInstitutionLoginWithAccountsByPollingWatcher,
    logPlaidItemActivityWatcher,
];
